import { useVariant } from "@unleash/nextjs"

const DEFAULT_POLLING_INTERVAL = 5_000 // 5 seconds

export const useTransactionListPollingInterval = (): number | undefined => {
  const { enabled, payload } = useVariant("transaction_list_polling")

  if (!enabled) {
    return undefined
  }

  const payloadInterval = Number(payload?.value)
  if (Number.isNaN(payloadInterval)) {
    return DEFAULT_POLLING_INTERVAL
  }

  return payloadInterval
}
